<template>
    <div :key="key" :class="[`input-custom`, { 'textarea-custom': $attrs.type === 'textarea','has-unit': $attrs.unit }]">
        <el-input
            v-model="_value"
            :style="{minWidth:parseFloat(width) + 'px'}"
            :title="_value"
            v-bind="$attrs"
            v-on="$listeners"
            @keyup.native.enter="$emit('enter-click')"
        />
        <span v-if="$attrs.unit" class="input-custom-unit">{{ $attrs.unit }}</span>
    </div>
</template>

<script>
export default {
  name: "InputCustom",

  inheritAttrs: false,

  props: {
    value: {
      default: "",
      type: [String, Number]
    },

    width: {
      default: "220",
      type: [String, Number]
    }
  },

  data() {
    return {
      key: `InputCustomID-${Math.random()
        .toString(36)
        .slice(2)}`,
      attrs: {}
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  }
};
</script>

<style lang="scss">
    .input-custom {
        display: inline-block;
        .el-input__inner {
            padding: 0 10px;
        }
        &.has-unit {
            position: relative;
            .el-input__inner {
                padding-right: 50px;
            }
        }
        &-unit {
            position: absolute;
            height: 100%;
            line-height: 32px;
            top: 0;
            right: 10px;
            color: #C4C9D0;
            font-size: 14px;
        }
    }

    .textarea-custom {
        width: 100%;
    }
</style>
